export default {
  //  Colors
  background: {
    default: "#0f172a",
  },

  sidenav: {
    button: "#1e293b",
  },

  text: {
    main: "#cbd5e1",
    focus: "#ffffff",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  brand: {
    main: "#06b6d4",
    focus: "#38bdf8",
  },

  black: {
    light: "#0f172a",
    main: "#020617",
    focus: "#020617",
  },

  primary: {
    main: "#06b6d4",
    focus: "#38bdf8",
  },

  secondary: {
    main: "#0284c7",
    focus: "#38bdf8",
  },

  lightblue: {
    main: "#38bdf8",
    focus: "#0284c7",
  },

  orange: {
    main: "#f59e0b",
    focus: "#d97706",
  },

  grey: {
    100: "#f8fafc",
    200: "#f1f5f9",
    300: "#e2e8f0",
    400: "#cbd5e1",
    500: "#94a3b8",
    600: "#64748b",
    700: "#475569",
    800: "#1e293b",
    900: "#0f172a",
  },

  borderCol: {
    main: "#334155",
    red: "#f43f5e",
    navbar: "rgba(56, 189, 248, 0.2)",
  },

  // Other colors
  info: {
    main: "#06b6d4",
    focus: "#38bdf8",
    charts: {
      100: "#38bdf8",
      200: "#0284c7",
      300: "#0284c7",
      400: "#0369a1",
      500: "#075985",
      600: "#0c4a6e",
    },
  },

  success: {
    main: "#10b981",
    focus: "#34d399",
  },

  warning: {
    main: "#f59e0b",
    focus: "#fbbf24",
  },

  error: {
    main: "#f43f5e",
    focus: "#fb7185",
  },

  light: {
    main: "#e9ecef",
    focus: "#ebeff4",
  },

  dark: {
    main: "#344767",
    focus: "#121241",
    body: "#030c1d",
  },

  gradients: {
    navbar: {
      deg: "123.64deg",
      main: "rgba(255, 255, 255, 0) -22.38%",
      state: "rgba(255, 255, 255, 0.039) 70.38%",
    },

    sidenav: {
      deg: "127.09",
      main: "rgba(15, 23, 42, 0.95) 19.41%",
      state: "rgba(30, 41, 59, 0.85) 76.65%",
    },

    borderLight: {
      angle: "94.43% 69.43% at 50% 50%",
      main: "#38bdf8 0%",
      state: "rgba(56, 189, 248, 0) 100%",
    },

    borderDark: {
      angle: "69.43% 69.43% at 50% 50%",
      main: "#06b6d4 0%",
      state: "rgba(6, 182, 212, 0) 100%",
    },

    cover: {
      deg: "159.02",
      main: "#0f172a 14.25%",
      state: "#1e293b 56.45%",
      stateSecondary: "#020617 86.14%",
    },

    cardDark: {
      deg: "126.97",
      main: "rgba(15, 23, 42, 0.90) 28.26%",
      state: "rgba(30, 41, 59, 0.85) 91.2%",
    },

    cardLight: {
      deg: "127.09",
      main: "rgba(15, 23, 42, 0.95) 19.41%",
      state: "rgba(30, 41, 59, 0.85) 76.65%",
    },

    card: {
      deg: "127.09",
      main: "rgba(15, 23, 42, 0.95) 19.41%",
      state: "rgba(30, 41, 59, 0.85) 76.65%",
    },

    menu: {
      deg: "126.97",
      main: "#0f172a 28.26%",
      state: "#1e293b 91.2%",
    },

    cardContent: {
      deg: "126.97",
      main: "rgb(6, 11, 40) 28.26%",
      state: "rgb(10, 14, 35) 91.2%",
    },

    box: {
      deg: "126.97",
      main: "rgba(6, 11, 40, 0.74) 28.26%",
      state: "rgba(10, 14, 35, 0.71) 91.2%",
    },

    bill: {
      deg: "127.09",
      main: "rgba(24, 29, 60, 0.94) 19.41%",
      state: "rgba(10, 14, 35, 0.49) 76.65%",
    },

    primary: {
      deg: "97.89",
      main: "#4318ff",
      state: "#9f7aea",
    },

    secondary: {
      main: "#627594",
      state: "#a8b8d8",
    },

    logo: {
      deg: "97.89",
      main: "#ffffff 70.67%",
      state: "rgba(117, 122, 140, 0) 108.55%",
    },

    info: {
      main: "#0075ff",
      state: "#21d4fd",
    },

    success: {
      main: "#01B574",
      state: "#c9fbd5",
    },

    warning: {
      main: "#f53939",
      state: "#fbcf33",
    },

    error: {
      main: "#f53c2b",
      state: "#f53c2b",
    },

    light: {
      main: "#ced4da",
      state: "#ebeff4",
    },

    dark: {
      main: "#141727",
      state: "#3a416f",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#7928ca",
      state: "#d6006c",
      border: "#efb6e2",
    },

    secondary: {
      main: "#627594",
      state: "#8ca1cb",
      border: "#dadee6",
    },

    info: {
      main: "#2152ff",
      state: "#02c6f3",
      border: "#b9ecf8",
    },

    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9",
    },

    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2",
    },

    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },

    light: {
      main: "#ced4da",
      state: "#d1dae6",
      border: "#f8f9fa",
    },

    dark: {
      main: "#141727",
      state: "#2c3154",
      border: "#c2c8d1",
    },
  },

  badgeColors: {
    primary: {
      basic: "#805ad5",
      background: "#f883dd",
      text: "#a3017e",
    },

    secondary: {
      basic: "#5974a2",
      background: "#e4e8ed",
      text: "#5974a2",
    },

    info: {
      basic: "#4299e1",
      background: "#abe9f7",
      text: "#08a1c4",
    },

    success: {
      basic: "#01b574",
      background: "#c9fbd5",
      text: "#01b574",
    },

    warning: {
      basic: "#ffb547",
      background: "#fef5d3",
      text: "#fbc400",
    },

    error: {
      basic: "#e31a1a",
      background: "#fc9797",
      text: "#bd0000",
    },

    light: {
      basic: "#ffffff",
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      basic: "#1E244B",
      background: "#1E244B",
      text: "#fff",
    },
  },

  inputColors: {
    backgroundColor: "#0f1535",
    borderColor: { main: "rgba(226, 232, 240, 0.3)", focus: "rgba(226, 232, 240, 0.6)" },
    boxShadow: "#628fc2",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
